import React, { useState } from "react";
import { useSelector } from "react-redux";
import { onKeyDown } from "../../../../service";
import ImportOldProjects from "../../MaterialLibrary/ImportOldProjects";
import classes from "./AddFromOldSystemBtn.module.css"
const AddFromOldSystemBtn = ({ changeLibraryData, contentBankItemList }) => {
    const [showImportOldProjects, setShowImportOldProjects] = useState(false)
    const texts = useSelector((state) => state.translate.texts);

    function closeImportOldPopup(e) {
        setShowImportOldProjects(false)
    }

    return (
        <>
            <div className={classes.BtnWarrper} onClick={() => { setShowImportOldProjects(true) }} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowImportOldProjects(true))}>
                <div className={classes.BtnIcon}></div>
                <div className={classes.BtnText}>{texts.importFromLast}</div>
            </div>
            {
                showImportOldProjects &&
                <ImportOldProjects closePopup={closeImportOldPopup} changeLibraryData={changeLibraryData} contentBankItemList={contentBankItemList}></ImportOldProjects>
            }
        </>

    )
}

export default AddFromOldSystemBtn;